import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-auth-offline',
    templateUrl: './auth-offline.component.html',
    styleUrls: ['./auth-offline.component.scss'],
    standalone: false
})
export class AuthOfflineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
